import ErrorInfoBox from './ErrorInfoBox';

export default ErrorInfoBox;
